"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.On = void 0;
const On = ({
  isEnabled,
  children
}) => !!isEnabled && children;
exports.On = On;
